/* eslint-disable object-curly-newline */
import Button from 'common/components/Button/Button';
import Modal from 'common/components/Modal/Modal';
import AlertsContext from 'common/contexts/alerts';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBeachEditor from 'sites/pages/BeachEditor/contexts/beachEditor';
import useWaiterArea from 'waiterAreas/contexts/waiterAreas';
import WaiterAreaForm from 'waiterAreas/pages/WaiterAreaFormPage/WaiterAreaForm';

const WaiterAreaSelector = () => {
  const { t } = useTranslation();
  const { setAlert } = useContext(AlertsContext);

  const {
    save, update, remove, fetchItems: fetchWaiterAreas, items: waiterAreas,
  } = useWaiterArea();

  const {
    setSelectedSelector, selectedSelector, mode, updateSeatInformation, site,
  } = useBeachEditor();

  const [showModal, setShowModal] = useState(false);
  const [selectedWaiterAreaModal, setSelectedWaiterAreaModal] = useState(null);

  const handleOpenModal = useCallback((waiterArea) => {
    setSelectedWaiterAreaModal(waiterArea);
    setShowModal(true);
  }, [setShowModal]);

  const handleDelete = useCallback(async (row) => {
    await remove(row.id);
    await fetchWaiterAreas();
  }, [remove, fetchWaiterAreas]);

  const handleSubmitModal = useCallback(async (data) => {
    const payload = { ...data };

    if (data.id) {
      const res = await update(payload.id, payload);

      if (!res.error) {
        setAlert(t('waiterAreas.successEdit'), 'success');
        fetchWaiterAreas();
        setShowModal(false);
      } else {
        setAlert(res.message, 'danger');
      }
    } else {
      const res = await save(payload);

      if (!res.error) {
        setAlert(t('waiterAreas.successAdd'), 'success');
        fetchWaiterAreas();
        setShowModal(false);
      } else {
        setAlert(res.message, 'danger');
      }
    }
  }, [fetchWaiterAreas, save, setAlert, t, update]);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  useEffect(() => {
    if (mode === 'waiter' && waiterAreas?.length) {
      setSelectedSelector({
        id: waiterAreas[0].id,
        type: 'waiter',
        waiter_area: waiterAreas[0],
      });
    }
  }, [mode, waiterAreas, setSelectedSelector]);

  useEffect(() => {
    fetchWaiterAreas();
  }, [fetchWaiterAreas]);

  useEffect(() => {
    if (waiterAreas?.length) {
      updateSeatInformation('waiter_area', waiterAreas);
    }
  }, [waiterAreas, updateSeatInformation]);

  return (
    <div className="selector-panel">
      { showModal && (
      <Modal confirmModal={() => {}} closeModal={handleCloseModal}>
        <WaiterAreaForm
          site={site.id}
          onSubmit={handleSubmitModal}
          waiterArea={selectedWaiterAreaModal}
        />
      </Modal>
      )}
      <Button
        color="primary"
        label={t('waiterAreas.addWaiterArea')}
        icon="fa-plus"
        onClick={handleOpenModal}
      />
      <div className="selectors">
        { waiterAreas && waiterAreas.map((item, index) => (
          <div
            key={index}
            alt={item.name}
            className={`selector ${item.id === selectedSelector.id && 'selected'}`}
            onClick={
              () => setSelectedSelector({
                id: item.id,
                type: 'waiter',
                waiter_area: item,
              })
            }
          >
            <div className="circleSelectorWrapper">
              <div
                className="circleSelector"
                style={{ backgroundColor: item.color }}
              />
            </div>
            <div className="selectorName">
              { item.name }
              {item.id === selectedSelector.id && (
                <p>
                  {t('common.clicOnMap')}
                </p>
              )}
            </div>
            <div className="actionsButton">
              <Button
                onClick={() => handleOpenModal(item)}
                icon="fa-pencil-alt"
                color="primary"
                transparent
              />
              <Button
                onClick={() => handleDelete(item)}
                icon="fa-trash-alt"
                color="danger"
                confirm
                transparent
                confirmMessage={t('waiterAreas.confirmDelete')}
              />
            </div>

          </div>
        ))}
        <div
          className={`selector ${selectedSelector.id === 'delete' && 'selected'}`}
          onClick={() => {
            setSelectedSelector({
              id: 'delete',
              type: 'furniture',
              waiter_area: null,
            });
          }}
        >
          <i className=" selector-icon fas fa-trash-alt" />
          <div className="selectorName">
            {t('common.delete')}
            {selectedSelector.id === 'delete' && 'selected' && (
            <p>
              {t('common.clicOnMapDelete')}
            </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaiterAreaSelector;
